import Paw from "common/components/Paw";

import styles from "../../styles/Loading.module.less";

const Loading = () => {
  return (
    <div className={styles.main}>
      <Paw pathFill="currentColor" className={styles.icon} />
    </div>
  );
};

export default Loading;
